import script from "./Avvio.vue?vue&type=script&setup=true&lang=js"
export * from "./Avvio.vue?vue&type=script&setup=true&lang=js"

import "./Avvio.vue?vue&type=style&index=0&id=37236e22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37236e22"]])

export default __exports__